import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetMoveForDispatchQueryVariables = Types.Exact<{
  moveId: Types.Scalars['bigint']['input'];
}>;


export type GetMoveForDispatchQuery = { __typename?: 'query_root', moves_by_pk?: { __typename?: 'moves', id: number, active: number, cancel_status?: string | null, consumer_name?: string | null, consumer_phone?: string | null, consumer_type?: string | null, customer_id?: number | null, deliver_by?: string | null, delivery_time?: string | null, driver_id?: number | null, lite: boolean, move_type: string, parent_move_id?: number | null, pickup_time?: string | null, ready_by?: string | null, reference_num?: string | null, status?: string | null, usecase_key?: string | null, vehicle_color?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_stock?: string | null, vehicle_vin?: string | null, vehicle_year?: string | null, driver?: { __typename?: 'drivers', id: number, user?: { __typename?: 'users', display_name: string } | null } | null, childMoves: Array<{ __typename?: 'moves', id: number, active: number, consumer_type?: string | null, deliver_by?: string | null, move_type: string, parent_move_id?: number | null, lite: boolean, pickup_time?: string | null, ready_by?: string | null, status?: string | null, usecase_key?: string | null, createdat?: string | null, lane?: { __typename?: 'lanes', id: number, duration_sec?: number | null } | null }>, parentMove?: { __typename?: 'moves', id: number, active: number, consumer_type?: string | null, deliver_by?: string | null, move_type: string, parent_move_id?: number | null, lite: boolean, status?: string | null, usecase_key?: string | null, lane?: { __typename?: 'lanes', id: number, duration_sec?: number | null } | null, childMoves: Array<{ __typename?: 'moves', id: number, active: number, deliver_by?: string | null, move_type: string, parent_move_id?: number | null, lite: boolean, pickup_time?: string | null, ready_by?: string | null, status?: string | null }> } | null, lane?: { __typename?: 'lanes', id: number, duration_sec?: number | null, distance_miles?: number | null, pickup: { __typename?: 'locations', id: number, address?: string | null, name?: string | null, latitude?: number | null, longitude?: number | null, timezone?: string | null }, delivery: { __typename?: 'locations', id: number, address?: string | null, name?: string | null, latitude?: number | null, longitude?: number | null } } | null, customer?: { __typename?: 'customers', id: number, name?: string | null, config?: object | null } | null, scenariotomoves: Array<{ __typename?: 'scenariotomoves', scenario: { __typename?: 'scenarios', id: number, status: string, scenario_key: string } }> } | null };


export const GetMoveForDispatchDocument = gql`
    query getMoveForDispatch($moveId: bigint!) {
  moves_by_pk(id: $moveId) {
    id
    active
    cancel_status
    consumer_name
    consumer_phone
    consumer_type
    customer_id
    deliver_by
    delivery_time
    driver_id
    driver {
      id
      user {
        display_name
      }
    }
    lite
    move_type
    parent_move_id
    pickup_time
    ready_by
    reference_num
    status
    usecase_key
    vehicle_color
    vehicle_make
    vehicle_model
    vehicle_stock
    vehicle_vin
    vehicle_year
    childMoves {
      id
      active
      consumer_type
      deliver_by
      move_type
      parent_move_id
      lite
      pickup_time
      ready_by
      status
      usecase_key
      createdat
      lane {
        id
        duration_sec
      }
    }
    parentMove {
      id
      active
      consumer_type
      deliver_by
      move_type
      parent_move_id
      lite
      status
      usecase_key
      lane {
        id
        duration_sec
      }
      childMoves {
        id
        active
        deliver_by
        move_type
        parent_move_id
        lite
        pickup_time
        ready_by
        status
      }
    }
    lane {
      id
      duration_sec
      distance_miles
      pickup {
        id
        address
        name
        latitude
        longitude
        timezone
      }
      delivery {
        id
        address
        name
        latitude
        longitude
      }
    }
    customer {
      id
      name
      config
    }
    scenariotomoves(
      where: {scenario: {status: {_neq: "deprecated"}}}
      order_by: {id: desc}
    ) {
      scenario {
        id
        status
        scenario_key
      }
    }
  }
}
    `;

/**
 * __useGetMoveForDispatchQuery__
 *
 * To run a query within a React component, call `useGetMoveForDispatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoveForDispatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoveForDispatchQuery({
 *   variables: {
 *      moveId: // value for 'moveId'
 *   },
 * });
 */
export function useGetMoveForDispatchQuery(baseOptions: Apollo.QueryHookOptions<GetMoveForDispatchQuery, GetMoveForDispatchQueryVariables> & ({ variables: GetMoveForDispatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMoveForDispatchQuery, GetMoveForDispatchQueryVariables>(GetMoveForDispatchDocument, options);
      }
export function useGetMoveForDispatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMoveForDispatchQuery, GetMoveForDispatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMoveForDispatchQuery, GetMoveForDispatchQueryVariables>(GetMoveForDispatchDocument, options);
        }
// @ts-ignore
export function useGetMoveForDispatchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMoveForDispatchQuery, GetMoveForDispatchQueryVariables>): Apollo.UseSuspenseQueryResult<GetMoveForDispatchQuery, GetMoveForDispatchQueryVariables>;
export function useGetMoveForDispatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMoveForDispatchQuery, GetMoveForDispatchQueryVariables>): Apollo.UseSuspenseQueryResult<GetMoveForDispatchQuery | undefined, GetMoveForDispatchQueryVariables>;
export function useGetMoveForDispatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMoveForDispatchQuery, GetMoveForDispatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMoveForDispatchQuery, GetMoveForDispatchQueryVariables>(GetMoveForDispatchDocument, options);
        }
export type GetMoveForDispatchQueryHookResult = ReturnType<typeof useGetMoveForDispatchQuery>;
export type GetMoveForDispatchLazyQueryHookResult = ReturnType<typeof useGetMoveForDispatchLazyQuery>;
export type GetMoveForDispatchSuspenseQueryHookResult = ReturnType<typeof useGetMoveForDispatchSuspenseQuery>;
export type GetMoveForDispatchQueryResult = Apollo.QueryResult<GetMoveForDispatchQuery, GetMoveForDispatchQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/moves/queries/getMoveForDispatch.query.gql}
 */
export async function getMoveForDispatch(
  variables: GetMoveForDispatchQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetMoveForDispatchQuery['moves_by_pk']>
export async function getMoveForDispatch(
  variables: GetMoveForDispatchQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetMoveForDispatchQuery>
export async function getMoveForDispatch(
  variables: GetMoveForDispatchQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetMoveForDispatchQuery['moves_by_pk'] | GetMoveForDispatchQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetMoveForDispatchQuery>(
    GetMoveForDispatchDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.moves_by_pk
}